import { BaseModel } from "@/models/base.model"
import type { Units } from "@/enums/units.enum"
import { type IRentalDispenseItem } from "@/interfaces/api/rental-dispense-item.interface"
import { unitToName } from "@/helper/enums/unit-helper"

export class RentalDispenseItem extends BaseModel implements IRentalDispenseItem {
  public static className = "RentalDispenseItem" // Used for socket communication.

  public static verboseName = "Verhuurartikel"

  id: string

  name: string

  unit: Units

  unitPricePerDay: string | undefined

  constructor(rentalDispenseItem: IRentalDispenseItem) {
    super(rentalDispenseItem)

    this.id = rentalDispenseItem.id
    this.name = rentalDispenseItem.name
    this.unit = rentalDispenseItem.unit
    this.unitPricePerDay = rentalDispenseItem.unitPricePerDay
  }

  public getDisplayText() {
    return `${this.name} ${this.getUnitName()} ${this.unitPricePerDay}`
  }

  public getUnitName() {
    return unitToName(this.unit)
  }
}
